import { NavLink, Outlet, useLocation } from 'react-router-dom'
import { useCart } from '../modules/cart/cart-provider.tsx'
import { usePublicSiteSettingsQuery } from '../modules/content/site-content.ts'

export function AppShell() {
  const { state } = useCart()
  const location = useLocation()
  const site = usePublicSiteSettingsQuery()
  const brand = site.data?.settings.brand
  const privateRoute = /^\/(?:admin|checkout|pedido|entrar|minha-conta)(?:\/|$)/.test(
    location.pathname,
  )
  const brandName = brand?.name ?? 'Momentos com Tintin'
  const tagline = brand?.tagline ?? 'Uma coleção para cada momento'
  const contactEmail = brand?.contactEmail ?? 'contato@momentoscomtintin.com.br'
  const instagramUrl = brand?.instagramUrl ?? 'https://instagram.com/passandotempocomtintin'
  return (
    <div className="site-shell">
      {privateRoute ? <meta name="robots" content="noindex,nofollow" /> : null}
      <a className="skip-link" href="#conteudo">
        Pular para o conteúdo
      </a>
      <header className="site-header">
        <NavLink className="brand" to="/" aria-label={`${brandName} — início`}>
          <span className="brand__mark" aria-hidden="true">
            <img
              src="/brand/tintin-logo-face.png"
              alt=""
              width="48"
              height="48"
              fetchPriority="high"
            />
          </span>
          <span className="brand__copy">
            <strong>{brandName}</strong>
            <small>{tagline}</small>
          </span>
        </NavLink>
        <nav aria-label="Navegação principal">
          <NavLink className="world-link" to="/">
            Momentos
          </NavLink>
          <NavLink to="/minha-conta/edicoes">Minhas Edições</NavLink>
          <NavLink className="cart-link" to="/checkout">
            Carrinho{' '}
            <span aria-label={`${state.offerIds.length} itens`}>{state.offerIds.length}</span>
          </NavLink>
        </nav>
      </header>
      <main id="conteudo" tabIndex={-1}>
        <Outlet />
      </main>
      <footer className="site-footer">
        <div className="site-footer__inner">
          <div>
            <strong>{brandName}</strong>
            <p>{tagline} · Brasil</p>
          </div>
          <nav aria-label="Links institucionais">
            <NavLink to="/sobre">Sobre</NavLink>
            <NavLink to="/privacidade">Privacidade</NavLink>
            <NavLink to="/termos">Termos</NavLink>
            <a href="/#novidades">Receber novidades</a>
            <NavLink to="/momentos/passando-tempo-com-tintin">Loja</NavLink>
            <NavLink to="/momentos/lendo-com-tintin">Histórias</NavLink>
            <a href={instagramUrl} target="_blank" rel="noopener noreferrer">
              Instagram
            </a>
            <a href={`mailto:${contactEmail}`}>E-mail</a>
          </nav>
        </div>
        <div className="site-footer__legal">
          <span>
            © {new Date().getFullYear()} {brandName} · Todos os direitos reservados
          </span>
        </div>
      </footer>
    </div>
  )
}
